import PostHeader from '@/components/PostHeader'
import PostCard from '@/components/Posts/PostCard'
import VideoPlayer from '@/components/VideoPlayer'
import { getDictionary, isHot97 } from '../dictionary'
import TinyMce from './TinyMce'
import dynamic from 'next/dynamic'
import useIsMobile from '../hooks/useIsMobile'
const Ad = dynamic(() => import('@/src/components/Ad'), { ssr: false })

export default function Post({ post, tags, topStories, host }) {

    const isMobile = useIsMobile()

    if (!post) return { notFound: true }

    const postId = `${getDictionary('postsPath')}${post.slug}`

    return (
        <>
            <div id='postMainDiv'
                className={isMobile ? 'w-screen grid grid-cols-1 lg:grid-cols-3 my-0 mx-0 md:my-12 md:mx-12' : 'grid grid-cols-1 lg:grid-cols-3 my-0'}>
                <main id='main' className={`lg:col-span-2 ${isHot97() ? 'text-white bg-black' : 'text-black bg-white'} lg:pl-12`}>
                    <PostHeader post={post} tags={tags} host={host} />
                    <section className={`w-full font-[Oskari] ${isHot97() ? 'text-white bg-black' : 'text-black bg-white'} px-8 lg:px-0 lg:pr-8`}>
                        <VideoPlayer jwPlayerId={post.videoId} />
                        <Ad id='post-content-ad'
                            pos='1'
                            className='lg:flex hidden w-full text-center static my-5'
                            closeButton={false}
                            category={undefined}
                            postId={undefined} />
                        <Ad id='post-content-ad'
                            pos='incontent1'
                            className='lg:hidden flex w-full text-center static my-5'
                            closeButton={false}
                            category={undefined}
                            postId={undefined} />
                        <TinyMce key={`post-${postId}`} content={post.content} />
                    </section>
                </main>
                <aside className={`lg:col-span-1 ${isHot97() ? 'text-white bg-black' : 'text-black bg-white'} md:pe-12 pt-16`}>
                    <Ad id='sidebar1-ad' pos='btf1' className='m-adspace--post-sidebar' postId={postId} />
                    <>
                        <p className='font-[Judge] font-bold text-4xl leading-10 text-black bg-hot-yellow h-20 text-left pt-5 pl-6 mb-6 mt-0'>{getDictionary('moreFrom')}</p>
                        <div className='w-full min-h-fit'>
                            {
                                topStories.map(post => {
                                    return <PostCard 
                                        key={post.sys.id}
                                        post={post}
                                        articleStyle={'flex flex-col mb-8'}
                                        imageWrapperStyle='h-100 w-full transition-opacity opacity-0 duration-[1s] object-cover'
                                        setContent={false}
                                    />
                                })
                            }
                        </div>
                    </>
                </aside>
            </div>
        </>
    )
}
